// extracted by mini-css-extract-plugin
module.exports = {"tag":"ReportTag_tag__1mqDl","tips":"ReportTag_tips__3pqgN"};